<template>
  <div class="map">
    <div :id="id">
      <loader-component :with_text="true" text="Sedang memuat peta" />
    </div>
  </div>
</template>

<script>
import Axios from "axios";
import $ from "jquery";
import loader_component from "@/views/components/loader.vue";
import * as Highcharts from "highcharts/highmaps.js";
import id_map from "@/plugins/maps/countries/id-all.js";
import my_map from "@/plugins/maps/countries/my-all.js";
import world_map from "@/plugins/maps/world.js";
import "highcharts/modules/accessibility.js";
import "highcharts/themes/grid.js";
Highcharts.maps["id"] = id_map.load_data();
Highcharts.maps["my"] = my_map.load_data();

export default {
  name: "bubble_maps_chart",
  props: {
    dataset: Array,
    mapapi: String,
    id: {
      Type: String,
      default: () => {
        return "mapcontainer";
      },
    },
    color: {
      Type: String,
      default: () => {
        return "#f16528";
      },
    },
    clickable: {
      Type: Boolean,
      default: () => {
        return true;
      },
    },
  },
  components: {
    "loader-component": loader_component,
  },
  data() {
    return {
      data: this.dataset,
      setdata: [],
    };
  },
  methods: {
    getData: function () {
      var self = this;

      Axios
        .get(self.mapapi)
        .then((response) => {
          if (response.status == 200) {
            this.setdata = response.data;
          } else {
            this.setdata = [];
          }
        })
        .catch(function (err) {
          console.log(err);
        })
    },
    countriesConfig: function (vn, country_key) {
      var config_map = {
        chart: {
          map: country_key,
          height: 35 + "%",
          backgroundColor: "transparent",
          renderTo: vn.id
        },
        credits: {
          enabled: false,
        },
        exporting: {
          enabled: false,
        },
        title: {
          text: "",
        },
        legend: {
          enabled: false,
        },
        mapNavigation: {
          enabled: true,
          buttonOptions: {
            verticalAlign: "bottom",
          },
          enableMouseWheelZoom: false,
        },
        series: [
          {
            type: "map",
            name: "Provinsi",
            color: "#f16528",
            nullColor: "#2B2F3B",
            enableMouseTracking: true,
            data: this.setdata,
            dataLabels: {
              formatter: function () {
                return (
                  '<span class="point-name" data-id="' +
                  this.point.hc_key +
                  '">' +
                  this.point.name +
                  "</span>"
                );
              },
              enabled: false,
              useHTML: true,
            },
            tooltip: {
              pointFormat: "{point.name} <br/> Jumlah Mentions: {point.z} ",
            },
            cursor: "pointer",
          },
          {
            type: "mapbubble",
            name: "Jumlah Mentions",
            joinBy: "hc_key",
            color: this.color,
            data: this.setdata,
            maxSize: "12%",
            marker: {
              fillOpacity: 0.6,
            },
            tooltip: {
              pointFormat: "{point.name} <br/> Jumlah Mentions: {point.z} ",
            },
            dataLabels: {
              allowOverlap: true,
              format:
                '<span class="point-name" data-code="{point.hc_key}">{point.name}</span>',
              enabled: true,
            },
            point: {
              events: {
                click: function () {
                  if (vn.clickable) {
                    vn.$parent.bubbleClicked(this);
                  }
                },
              },
            },
            cursor: "pointer",
            zIndex: 150,
          },
        ],
      };
      return config_map;
    },
    worldConfig: function (nv) {
      var self = this;
      var map_config = {
        chart: {
          map: world_map.load_data(),
          height: 35 + "%",
          backgroundColor: "transparent",
          renderTo: self.id
        },
        credits: {
          enabled: false,
        },
        exporting: {
          enabled: false,
        },
        title: {
          text: "",
        },
        legend: {
          enabled: false,
        },
        mapNavigation: {
          enabled: true,
          buttonOptions: {
            verticalAlign: "bottom",
          },
          enableMouseWheelZoom: false,
        },
        series: [
          {
            type: "map",
            name: "Provinsi",
            color: "#f16528",
            nullColor: "#2B2F3B",
            enableMouseTracking: true,
            data: nv.data,
            dataLabels: {
              formatter: function () {
                return (
                  '<span class="point-name" data-id="' +
                  this.point.hc_key +
                  '">' +
                  this.point.name +
                  "</span>"
                );
              },
              enabled: false,
              useHTML: true,
            },
            tooltip: {
              pointFormat: "{point.name} <br/> Jumlah Mentions: {point.z} ",
            },
            cursor: "pointer",
          },
          {
            type: "mapbubble",
            name: "Negara",
            joinBy: "hc_key",
            color: this.color,
            data: nv.data,
            maxSize: "12%",
            marker: {
              fillOpacity: 0.6,
            },
            tooltip: {
              pointFormat: "{point.name} <br/> Jumlah Mentions: {point.z} ",
            },
            dataLabels: {
              allowOverlap: true,
              format:
                '<span class="point-name" data-code="{point.hc_key}">{point.name}</span>',
              enabled: true,
            },
            point: {
              events: {
                click: function () {
                  if (nv.clickable) {
                    if (this?.province == true) {
                      $("#mapcontainer").html('');
                      nv.$parent.title_map = "Jumlah Mentions Media Online per Provinsi di " + this.name;
                      nv.$parent.showCard = true;
                      nv.$parent.showPopular = true;
                      nv.$parent.isShowProv = false;
                      new Highcharts.mapChart(self.countriesConfig(self, this.hc_key));
                    } else {
                      nv.$parent.title_map = "Jumlah Mentions Media Online di " + this.name;
                      nv.$parent.bubbleClicked(this, true);
                    }
                  }
                },
              },
            },
            cursor: "pointer",
            zIndex: 99,
          },
        ],
      };
      return map_config;
    },
  },
  mounted: function () {
    if (this.data != null) {
      this.getData();
      new Highcharts.mapChart(this.worldConfig(this));
    }
  },
};
</script>

<style scoped>
.highcharts-point {
  z-index: 999 !important;
}

.highcharts-text-outline {
  stroke-width: 0px;
  color: #f5ecec;
}
</style>
